(() => {
  const start = () => {
    let observer;
    const reveal = (template) => {
      observer?.unobserve(template.parentElement);
      template.replaceWith(template.content);
    };
    const sync = () => {
      const pending = [...document.querySelectorAll('template[data-natural-deferred-media]')];
      if (!pending.length) {
        observer?.disconnect();
        document.removeEventListener('natural:chapter-change', sync);
        return;
      }
      const deck = document.documentElement.classList.contains('natural-home-swiper-ready');
      pending.forEach((template) => {
        if (deck) {
          if (template.closest('.is-natural-near')) reveal(template);
        } else if (observer) {
          observer.observe(template.parentElement);
        } else {
          reveal(template);
        }
      });
    };
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (document.documentElement.classList.contains('natural-home-swiper-ready')) return;
        entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
          entry.target.querySelectorAll('template[data-natural-deferred-media]').forEach(reveal);
        });
      }, { rootMargin: '200px' });
    }
    document.addEventListener('natural:chapter-change', sync);
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', sync);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
